import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const EuroCoinIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <circle cx="10" cy="10" r="8.25" stroke="currentColor" fill="none" strokeWidth="1.5" />
            <path
                d="M13.15 7.05933C12.0407 5.95001 9.80089 5.25932 8.00096 7.05933C5.841 9.21937 7.00012 11.8 7.75012 12.7C8.6501 13.6 10.99 14.86 13.15 12.7"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                fill="none"
            />
            <path d="M5.05005 8.91992H11.35" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M5.05005 11.1699H11.35" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </SvgIcon>
    );
};
